import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";

export default function Breadcrumbs({ trail }) {
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="flex flex-wrap items-center gap-2 font-mono text-xs uppercase tracking-widest text-white/40">
      {trail.map((t, i) => (
        <span key={t.path} className="flex items-center gap-2">
          {i > 0 && <CaretRight className="h-3 w-3 text-brand-red" />}
          {i === trail.length - 1 ? (
            <span className="text-white/70">{t.name}</span>
          ) : (
            <Link to={t.path} className="transition-colors hover:text-brand-red">{t.name}</Link>
          )}
        </span>
      ))}
    </nav>
  );
}
